import { API_PREFIX } from './api-request';

export function isDevelopmentVersion() {
  return API_PREFIX != 'https://app.coastalbabysitters.com.au/api/';
}
